<template>
	<div class="news">
		<div class="news_pc" v-if="!isPhone">
			<div class="news_con">
				<div class="nc_box1">
					<div class="nc_box1_left" data-aos="fade-up">
						<swiper class="hn_swiper" :options="swiperOptions">
							<swiper-slide class="hn_slide" v-for="(item, index) in banner" :key="index">
								<img @click="toDetail(item)" :src="staticImg + item.image" />
								<p @click="toDetail(item)" class="ban_text">
									{{ item.title }}
								</p>
							</swiper-slide>
							<div class="swiper-pagination pagination44" slot="pagination"></div>
						</swiper>
					</div>
					<div class="nc_box1_right">
						<div class="ntit flex1">
							<div class="ntit_left">公告公示</div>
							<div class="ntit_right" @click="lookMore(31, '公告公示')">
								<span>查看全部</span>
								<i class="el-icon-arrow-right"></i>
							</div>
						</div>
						<ul class="news_ul">
							<li data-aos="fade-up" class="news_li" v-for="(item, index) in gongGao" :key="index" @click="toDetail(item)">
								<p class="nt_p1">{{ item.title }}</p>
								<p class="nt_p2">
									{{ item.summary }}...[查看详情]
								</p>
								<p class="nt_p3">{{ item.publishtime }}</p>
							</li>
						</ul>
					</div>
				</div>
				<div class="nc_box2">
					<div class="ntit flex1">
						<div class="ntit_left">最新资讯</div>
						<div class="ntit_right" @click="lookMore(30, '最新资讯')">
							<span>查看全部</span>
							<i class="el-icon-arrow-right"></i>
						</div>
					</div>
				</div>
				<div class="nc_box3">
					<div data-aos="fade-up" class="nc3_item" v-for="(item, index) in newsArr" :key="index" @click="toDetail(item)">
						<div class="nc3_item_wrap">
							<div class="nc3_item_img">
								<img :src="staticImg + item.image" />
							</div>
							<div class="nc3_item_text">
								<p class="n3_text_p1">{{ item.title }}</p>
								<p class="n3_text_p2">{{ item.publishtime }}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="record_box">
					<record></record>
				</div>
			</div>
		</div>
		<div class="news_phone" v-if="isPhone">
			<Header2 :searchShow="true" pageTitle="新闻资讯"></Header2>
			<div class="zr_tab_box flex2">
				<div @click="zrTabChange(index)" v-for="(item, index) in tabList" :key="index" class="zr_tab_item"
					:class="pcrut == index ? 'ph_act1' : ''">
					{{ item }}
				</div>
			</div>
			<div class="zxzx" v-if="pcrut == 0">
				<swiper class="hn_swiper2" :options="swiperOptions6">
					<swiper-slide class="hn_slide" v-for="(item, index) in banner" :key="index">
						<img @click="toDetail(item)" :src="staticImg + item.image" />
						<div @click="toDetail(item)" class="ban_text">
							<p class="ban_text_p1">{{ item.title }}</p>
							<p class="ban_text_p2">{{item.publishtime}}</p>
						</div>
					</swiper-slide>
				</swiper>
				<ul class="pnews_ul">
					<li class="pnews_li flex1" v-for="item in newsArr" :key="item.id" @click="toDetail(item)">
						<div class="pnews_li_left">
							<p class="li_left_p1 ellip22">{{ item.title }}</p>
							<p class="li_left_p2">{{ item.publishtime }}</p>
						</div>
						<div class="pnews_li_right">
							<img :src="item.image?(staticImg + item.image):noImg" />
						</div>
					</li>
                    <div class="look_more" v-if="newsArr.length">
                        <span @click="loogMore(1)">查看全部 ></span>
                    </div>
				</ul>
			</div>
			<div class="gsgg" v-if="pcrut == 1">
				<ul class="gs_ul">
					<li class="gs_li" v-for="(item, index) in gongGao" :key="index" @click="toDetail(item)">
						<p class="gs_li_p1">{{ item.title }}</p>
						<p class="gs_li_p2">{{ item.publishtime }}</p>
					</li>
                    <div class="look_more" v-if="gongGao.length">
                        <span @click="loogMore(2)">查看全部 ></span>
                    </div>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isPhone: this.$isMobile,
			banner: [],
			gongGao: [],
			newsArr: [],
			staticImg: this.$staticImg + "/",
			swiperOptions: {
				// 分页器配置
				pagination: {
					el: ".pagination44",
					clickable: true,
				},
				// 导航按钮配置
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			},
			swiperOptions6: {
				// 导航按钮配置
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			},
			pcrut: 0,
			tabList: ["最新资讯", "公告公示"],
            noImg:require("@/images/noimg.png"),
		};
	},
	created() {
		this.news();
	},
	methods: {
		async news() {
			const res = await this.$api.news();
			if (res.code == 1) {
				this.banner = res.data.banner;
				this.gongGao = res.data.gsgg;
				this.newsArr = res.data.new;
			}
		},
		toDetail(item) {
			this.$router.push(
				"/newsDetail?xid=" + item.id + "&typeid=" + item.typeid
			);
		},
		lookMore(a, b) {
			this.$router.push({
				path: "/newsList",
				query: {
					id: a,
					name: b,
				},
			});
		},
		zrTabChange(index) {
			this.pcrut = index;
		},
        loogMore(a){
            this.$router.push({
				path: "/allList",
				query: {
					type: a,
				},
			});
        }
	},
};
</script>

<style lang="scss">
.look_more{
    text-align: center;
    margin-top: 0.8rem;
    span{
        background-color: #d43235;
        color: #fff;
        padding: 10px 20px;
        border-radius: 5px;
    }
}
.pagination44 {
	box-sizing: border-box;
	display: flex;
	justify-content: flex-end;
	padding-right: 20px;
	bottom: 20px !important;
}
.ntit {
	position: relative;
	color: #000;
	font-size: 26px;
	padding-left: 20px;
	margin-bottom: 20px;
	&::after {
		content: "";
		position: absolute;
		left: 0;
		top: 50%;
		margin-top: -14px;
		width: 8px;
		height: 28px;
		background-color: #d43235;
	}
	.ntit_right {
		color: #828282;
		font-size: 16px;
		padding-right: 20px;
		cursor: pointer;
		&:hover {
			color: #d43235;
		}
	}
}
.news {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	.news_pc {
		margin-top: 76px;
		padding: 40px 0 80px 0;
		background-image: url("../../images/bgimg3.png");
		box-sizing: border-box;
		.news_con {
			max-width: 1324px;
			min-width: 950px;
			margin: 0 auto;
			padding: 0 20px;
			.nc_box1 {
				margin-bottom: 30px;
				display: flex;
				.nc_box1_left {
					width: 51.8%;
					overflow: hidden;
					.hn_swiper {
						width: 100%;
						.hn_slide {
							width: 100%;
							display: flex;
							justify-content: center;
							flex-wrap: wrap;
							position: relative;
							cursor: pointer;
							img {
								width: 100%;
								transition: transform 0.5s ease;
								&:hover {
									transform: scale(1.1);
								}
							}
							.ban_text {
								position: absolute;
								left: 0;
								bottom: 0;
								right: 0;
								background-color: rgba(0, 0, 0, 0.4);
								padding: 20px 28px;
								text-overflow: ellipsis;
								white-space: nowrap;
								z-index: 8;
								color: #fff;
								font-size: 24px;
								line-height: 1.2;
								box-sizing: border-box;
								text-align: left;
							}
						}
						.swiper-pagination-fraction,
						.swiper-pagination-custom,
						.swiper-pagination-bullet-active {
							opacity: 1;
							background: #d43235 !important;
						}
					}
				}
				.nc_box1_right {
					flex: 1;
					overflow: hidden;
					padding-left: 50px;
					.news_ul {
						align-items: flex-start;
						.news_li {
							padding-bottom: 18px;
							margin-bottom: 24px;
							border-bottom: 1px solid #dedddc;
							cursor: pointer;
							&:hover {
								.nt_p1 {
									color: #d43235;
								}
							}
							p {
								text-align: left;
							}
							.nt_p1 {
								color: #000;
								font-size: 24px;
								line-height: 1.5;
								margin-bottom: 10px;
							}
							.nt_p2 {
								color: #828282;
								font-size: 16px;
								line-height: 1.5;
								height: 54px;
								overflow: hidden;
								position: relative;
							}
							.nt_p3 {
								color: #999;
								font-size: 14px;
								margin-top: 10px;
							}
						}
					}
				}
			}
			.nc_box2 {
				margin-bottom: 20px;
			}
			.nc_box3 {
				display: flex;
				flex-wrap: wrap;
				margin: 0 -10px;
				.nc3_item {
					width: 33.3%;
					padding: 0 10px;
					margin-bottom: 30px;
					box-sizing: border-box;
					cursor: pointer;
					&:hover {
						img {
							transform: scale(1.1);
						}
						.nc3_item_text {
							.n3_text_p1 {
								color: #d43235 !important;
							}
						}
					}
					.nc3_item_wrap {
						background-color: #fff;
						padding: 20px;
						.nc3_item_img {
							overflow: hidden;
							img {
								width: 100%;
								transition: transform 0.5s ease;
							}
						}
						.nc3_item_text {
							padding-top: 18px;
							p {
								text-align: left;
							}
							.n3_text_p1 {
								color: #333;
								font-size: 18px;
								line-height: 1.8;
								margin-bottom: 12px;
								height: 64px;
								overflow: hidden;
							}
							.n3_text_p2 {
								color: #999;
								font-size: 16px;
							}
						}
					}
				}
			}
			.record_box {
				margin-top: 30px;
			}
		}
	}
	@media screen and (max-width: 1580px) {
		.news_pc {
			.news_con {
				.nc_box1 {
					.nc_box1_left {
						.hn_swiper {
							.hn_slide {
								.ban_text {
									font-size: 20px;
								}
							}
						}
					}
					.nc_box1_right {
						.news_ul {
							.news_li {
								.nt_p1 {
									font-size: 20px;
								}
							}
						}
					}
				}
			}
		}
	}
	.news_phone {
		background-image: url("../../images/bgimg3.png");
		.head2_wrap .head2_box3 {
			top: 2.4rem !important;
		}
		.zxzx {
			margin-top: 2.4rem;
			min-height: 80vh;
			padding-bottom: 2.8rem;
			.hn_swiper2 {
				width: 100%;
				padding: 0 0.29rem;
				box-sizing: border-box;
				.hn_slide {
					width: 100%;
					position: relative;
					border-radius: 5px;
					overflow: hidden;
					img {
						width: 100%;
						display: block;
					}
					.ban_text {
						position: absolute;
						bottom: 0;
						left: 0;
						right: 0;
						background-color: rgba(0, 0, 0, 0.4);
						padding: 0.13rem 0.45rem;
						.ban_text_p1 {
							color: #fff;
							font-size: 17px;
							line-height: 1.6;
							margin-bottom: 0.1rem;
							text-align: left;
						}
						.ban_text_p2 {
							color: #fff;
							font-size: 10px;
							text-align: left;
						}
					}
				}
				.swiper-pagination-fraction,
				.swiper-pagination-custom,
				.swiper-pagination-bullet-active {
					opacity: 1;
					background: #d43235 !important;
				}
			}
			.pnews_ul {
				.pnews_li {
					padding: 0.4rem 0.6rem;
					border-bottom: 1px solid #dedede;
					.pnews_li_left {
						flex: 1;
						margin-right: 0.67rem;
						.li_left_p1 {
							color: #333;
							font-size: 17px;
							line-height: 1.7;
							margin-bottom: 0.15rem;
							text-align: left;
						}
						.li_left_p2 {
							color: #999;
							font-size: 12px;
							line-height: 1.8;
							text-align: left;
						}
					}
					.pnews_li_right {
						width: 2.667rem;
						flex-shrink: 0;
						img {
							border-radius: 5px;
							width: 100%;
						}
					}
				}
			}
		}
		.gsgg {
			padding: 2.6rem 0 2.8rem 0.27rem;
			overflow: hidden;
			min-height: 80vh;
			.gs_ul {
				.gs_li {
					padding: 0.4rem 0.6rem;
					border-bottom: 1px solid #dedede;
					.gs_li_p1 {
						color: #333;
						font-size: 17px;
						line-height: 1.7;
						margin-bottom: 0.15rem;
						text-align: left;
					}
					.gs_li_p2 {
						color: #999;
						font-size: 12px;
						line-height: 1.8;
						text-align: left;
					}
				}
			}
		}
	}
}
</style>